export interface Service {
  id: string;
  name: string;
  description: string;
  price: number;
  duration: number; // minutes
  badge?: string;
  badgeColor?: string;
  vehicleTypes: string[];
  icon: string;
}

export interface CustomerInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  vehicleYear: string;
  vehicleMake: string;
  vehicleModel: string;
  notes: string;
  isGuest: boolean;
}

export interface BookingState {
  service: Service | null;
  date: string | null;
  timeSlot: string | null;
  vehicleType: string;
  customer: CustomerInfo | null;
  bookingRef: string | null;
}

export const SERVICES: Service[] = [
  {
    id: 'svc-001',
    name: 'Exterior Wash & Dry',
    description: 'Hand wash, wheel clean, tire dressing, and streak-free dry. Great for regular upkeep.',
    price: 49,
    duration: 60,
    badge: 'Quick',
    badgeColor: 'bg-emerald-100 text-emerald-700',
    vehicleTypes: ['sedan', 'suv', 'truck', 'coupe'],
    icon: '🚿',
  },
  {
    id: 'svc-002',
    name: 'Interior Detail',
    description: 'Full vacuum, surface wipe-down, glass clean, leather conditioning, and odor treatment.',
    price: 129,
    duration: 120,
    badge: 'Popular',
    badgeColor: 'bg-blue-100 text-blue-700',
    vehicleTypes: ['sedan', 'suv', 'truck', 'coupe'],
    icon: '🪑',
  },
  {
    id: 'svc-003',
    name: 'Full Detail Package',
    description: 'Complete interior + exterior detail. Our most comprehensive single-day service.',
    price: 229,
    duration: 240,
    badge: 'Best Value',
    badgeColor: 'bg-accent/10 text-accent',
    vehicleTypes: ['sedan', 'suv', 'truck', 'coupe'],
    icon: '✨',
  },
  {
    id: 'svc-004',
    name: 'Ceramic Coating',
    description: '2-year ceramic protection layer. Includes full decontamination wash and paint prep.',
    price: 699,
    duration: 480,
    badge: 'Premium',
    badgeColor: 'bg-purple-100 text-purple-700',
    vehicleTypes: ['sedan', 'suv', 'coupe'],
    icon: '💎',
  },
  {
    id: 'svc-005',
    name: 'Paint Correction',
    description: 'Machine polish to remove swirl marks, light scratches, and oxidation. Restores gloss.',
    price: 449,
    duration: 360,
    badge: null,
    vehicleTypes: ['sedan', 'suv', 'coupe'],
    icon: '🔧',
  },
  {
    id: 'svc-006',
    name: 'Engine Bay Clean',
    description: 'Degreasing and detailing of the engine bay. Improves appearance and helps spot leaks.',
    price: 89,
    duration: 90,
    badge: null,
    vehicleTypes: ['sedan', 'suv', 'truck', 'coupe'],
    icon: '⚙️',
  },
];

export const VEHICLE_TYPES = [
  { id: 'sedan', label: 'Sedan' },
  { id: 'coupe', label: 'Coupe / Hatchback' },
  { id: 'suv', label: 'SUV / Crossover' },
  { id: 'truck', label: 'Truck / Van' },
];

export const TIME_SLOTS = [
  { id: 'ts-0800', time: '8:00 AM', available: true },
  { id: 'ts-0900', time: '9:00 AM', available: false },
  { id: 'ts-1000', time: '10:00 AM', available: true },
  { id: 'ts-1100', time: '11:00 AM', available: true },
  { id: 'ts-1200', time: '12:00 PM', available: false },
  { id: 'ts-1300', time: '1:00 PM', available: true },
  { id: 'ts-1400', time: '2:00 PM', available: true },
  { id: 'ts-1500', time: '3:00 PM', available: false },
  { id: 'ts-1600', time: '4:00 PM', available: true },
  { id: 'ts-1700', time: '5:00 PM', available: true },
];